import script from "./CompanyDetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyDetailPage.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyDetailPage.vue?vue&type=style&index=0&id=23a7085a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23a7085a"]])

export default __exports__